var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidemenuicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6073 24.4232H4.51036V21.8753H5.70391V23.1493H22.4137V5.31366H21.2201V4.03969H23.6073V24.4232ZM24.8008 7.8616V9.13557H25.9944V26.9712H9.28458V25.6972H8.09103V28.2451H27.1879V7.8616H24.8008ZM0.929688 0.217773V20.6013H20.0266V0.217773H0.929688ZM6.89747 19.3273H2.12324V14.2315H6.89747V19.3273ZM6.89747 12.9575H2.12324V7.8616H6.89747V12.9575ZM6.89747 6.58763H2.12324V1.49174H6.89747V6.58763ZM12.8653 19.3273H8.09103V14.2315H12.8653V19.3273ZM12.8653 12.9575H8.09103V7.8616H12.8653V12.9575ZM12.8653 6.58763H8.09103V1.49174H12.8653V6.58763ZM18.833 19.3273H14.0588V14.2315H18.833V19.3273ZM18.833 12.9575H14.0588V7.8616H18.833V12.9575ZM18.833 6.58763H14.0588V1.49174H18.833V6.58763Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenuicon);
export default __webpack_public_path__ + "static/media/sidemenuicon.19efec0975c53295f0c335b77ef53729.svg";
export { ForwardRef as ReactComponent };